import React from "react";
import "./StartTrading.css";
import { Container, Col, Row } from "react-bootstrap";
import ReadMore from "../../CommonUI/ReadMoreBtn/ReadMore";
import StartImg from "../../../Images/start-trading.png";
function StartTrading() {
  return (
    <>
      <section className="start-market">
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              <img
                className="img-fluid start-trading-img"
                src={StartImg}
                alt="StartImg"
              />
            </Col>
            <Col md={6}>
              <h2>
                Start trading
                <br /> right away!
              </h2>
              <p>We won't let your Ledger Balance sit idle.</p>
              {/* <button>Sign Up</button> */}
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default StartTrading;
